
import { DAILY_WARM_TIPS } from '../constants/dailyWarmTips';

export function getRandomWarmTip(): string {
    return pickWarmTipForUser("default");
}

export function pickWarmTipForUser(userKey: string): string {
    if (!DAILY_WARM_TIPS.length) return '';
    
    // Get YYYY-MM-DD
    const today = new Date().toISOString().split('T')[0];
    const seed = `${today}-${userKey}`;
    
    let hash = 0;
    for (let i = 0; i < seed.length; i++) {
        hash = (hash * 31 + seed.charCodeAt(i)) | 0;
    }
    
    const index = Math.abs(hash) % DAILY_WARM_TIPS.length;
    return DAILY_WARM_TIPS[index];
}
